import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";

export default function CaseServiceFolderRoute() {
  return <AdminOperationsScreen screenIdOverride="digital-service-folder-builder" />;
}
